import React from 'react'

import Dialog, { DialogProps } from '@components/shared/Dialog'

type Props = Omit<DialogProps, 'cancelBtn' | 'okBtn'> & {
  message: string
}

const AlertDialog: React.FC<Props> = (props: Props) => {
  return (
    <Dialog {...props} okBtn>
      <p className="whitespace-normal">{props.message}</p>
    </Dialog>
  )
}

export default AlertDialog
